module.exports = __webpack_public_path__ + "static/PartnerLogos-794de93cc985a2c7fd201066ccaa7665.png";